// App version metadata. Bump APP_VERSION and APP_UPDATED on each release.
export const APP_VERSION = "1.5.0";
// ISO datetime of the last version update
export const APP_UPDATED = "2026-08-19T10:00:00+02:00";
